import './DonationConfirm.css';
import { useEffect } from 'react';
import ReactGA from "react-ga4";
import { Helmet } from 'react-helmet';
import { useLocation, useNavigate } from 'react-router-dom';

export default function DonationConfirm() {
    const location = useLocation()
    useEffect(()=>{
      ReactGA.send({ hitType: "pageview", page: location.pathname, title: 'Signup Success Page' });
    }, []);
    const navigate = useNavigate();
    function navigateToLoginPage() {
      navigate('/site/signin');
    }
    return <div className="donation-confirm-container" style={{display:'flex',justifyContent:'center', flexDirection: 'column',width: "50%",marginRight: "auto",marginLeft: "auto"}}>
      <Helmet>
        <meta charSet="utf-8" />
        <title>Signup Success</title>
      </Helmet>
      <div style={{ margin: '5rem auto' }}>
        <p>Thank you for subscribing to Blue Planet Ecosystem.</p>
        <p>You are a valuable member of our growing community. You may now login to your account, receive special news and updates, and track the progress of your forest as we work toward a common goal.</p>
        <button style={{
          background: "green",
          color: "white",
          border: "0",
          padding: "0.3rem 1.5rem",
          borderRadius: "1rem",
          cursor: "pointer"
        }} onClick={navigateToLoginPage}>Go to login page</button>
      </div>
    </div>
}